import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import {formatNumberLocalized} from "../../../../utils/number";
import getRequiredError from "../utils/getRequiredError";
import {createIntRegex} from "../../../../regex/common";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkInt() || checkNumber() || checkMin() || checkMax() || checkDecimalDigits();
}

function checkRequired() {
    if ($value !== null) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}

function checkInt() {
    if ($value === null) {
        return null;
    }

    const {decimalDigits} = $rules;

    const ruleValue = getRuleValue(decimalDigits, $allValues);

    if (ruleValue !== undefined) {
        return null;
    }

    if (String($value).match(createIntRegex()) !== null) {
        return null;
    }

    return getRuleError(decimalDigits, $allValues, translate('Enter an integer'));
}

function checkNumber() {
    if ($value === null) {
        return null;
    }

    if (!isNaN($value)) {
        return null;
    }

    return translate('Enter a number');
}

function checkMin() {
    if ($value === null) {
        return null;
    }

    const {min} = $rules;

    if (min === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(min, $allValues);

    if ($value >= ruleValue) {
        return null;
    }

    return getRuleError(min, $allValues, translate('Min: ::number', {
        number: formatNumberLocalized(ruleValue) + ($options.unit ? ' ' + $options.unit : '')
    }));
}

function checkMax() {
    if ($value === null) {
        return null;
    }

    const {max} = $rules;

    if (max === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(max, $allValues);

    if ($value <= ruleValue) {
        return null;
    }

    return getRuleError(max, $allValues, translate('Max: ::number', {
        number: formatNumberLocalized(ruleValue) + ($options.unit ? ' ' + $options.unit : '')
    }));
}

function checkDecimalDigits() {
    if ($value === null) {
        return null;
    }

    const {decimalDigits} = $rules;

    const ruleValue = getRuleValue(decimalDigits, $allValues);

    if (ruleValue !== undefined) {
        return null;
    }

    const decimalPart = String($value).split('.')[1];

    if (!decimalPart || decimalPart.length <= ruleValue) {
        return null;
    }

    return getRuleError(decimalDigits, $allValues, translate('Number of decimal digits: ::number', {number: ruleValue}));
}
